import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-cc-knowledge-center',
  templateUrl: './cc-knowledge-center.component.html',
  styleUrls: ['./cc-knowledge-center.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CcKnowledgeCenterComponent implements OnInit {

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setMessageHeight();
  }

  //Variables Declaration
  @Output() backToHomeClicked = new EventEmitter<void>();
  @Output() searchClicked = new EventEmitter<string>();
  @Input() knowledgeCenterMessages: any[];
  @Input() parentSearchKeyword: string;
  constructor() { }

  ngOnInit(): void {
    this.setMessageHeight();
  }

  setMessageHeight() {
    const templateHeight = window.innerHeight - $('.messageHeader').outerHeight() - 160;

    $('.messageSection').css('max-height', templateHeight + 'px');
  }

  backToHome() {
    this.parentSearchKeyword = '';
    this.backToHomeClicked.emit();
    
  }


  searchKnowledge() {
    //this.loaderService.setLoaderStatus(true);
   // this.isKnowledgeDataLoad = false;
    this.searchClicked.emit(this.parentSearchKeyword);
  }

  openUrl(url) {
    window.open(url, '_blank');
  }

}
